module.exports = __webpack_public_path__ + "img/logo-hy-b2c.f1445dc.svg";